import { Action } from 'redux'
import { ThunkAction } from 'redux-thunk'
import { RootState } from '../index'
import { createSkuService } from '../../api/skus'
import { BundlesTypes } from '../bundles/types'

export const fetchBundles = (): ThunkAction<void, RootState, unknown, Action<string>> => {
  const skuService = createSkuService()

  return async dispatch => {
    const response = await skuService.getBundles()
    const bundles = response.map(bundle => ({
      ...bundle,
      visible: true
    }))

    dispatch({
      type: BundlesTypes.SAVE_BUNDLES,
      payload: bundles
    })
  }
}
